import React, { useState } from "react";
import Topnavbar from "../components/navbar";
import Hero from "../components/banner";
import Footer from "../components/footer";
import ProductList from "../components/home";
import { Link } from 'react-router-dom';

const Home = () => {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <div className="Home">
      <Topnavbar />
      <Hero setSearchQuery={setSearchQuery} />
      <ProductList searchQuery={searchQuery} />
      <Footer />
    </div>
  );
};

export default Home;
